/**
 * Spalten-Definition fuer das Kanban-Board.
 *
 * LOCKED via Phase 3 CONTEXT.md: 7 Spalten in fester Reihenfolge.
 * Reihenfolge ist HARDCODED — kein Reorder per Drag&Drop.
 *
 * Labels (PR 3, 01.06.):
 *   Die End-Spalten heissen UI-seitig "Teamshop angelegt" / "Keine Rueckmeldung" /
 *   "Keine Rueckmeldung Hotlead". DB-Keys ('positiv' / 'negativ' / 'negativ_hotlead')
 *   bleiben unveraendert — UI-Refactor, kein DB-Refactor.
 *
 * Sortierung pro Spalte (BOARD-05 + PR 3, 01.06.):
 * - Spalten 1/2/3 (Follow-up-Pipeline): aelteste Karten oben (oldest_first via
 *   enteredStatusAt ASC) — wer am laengsten wartet ist zuerst dran.
 * - Spalten 4/5/6/7: aktuelle Aktivitaet oben (newest_first via
 *   enteredStatusAt DESC) — wer zuletzt in die Spalte kam ist oben.
 */

import type { LeadStatus } from '../types';

export interface ColumnDef {
  status: LeadStatus;
  label: string;
  sort: 'oldest_first' | 'newest_first';
  /**
   * Endspalten unterliegen dem 90-Tage-Filter (PR 3, 01.06.) — Karten die
   * laenger als 90 Tage in der Spalte sitzen werden ausgeblendet, ausser der
   * User schaltet das Toggle "Alle anzeigen" um.
   */
  isEndColumn?: boolean;
}

export const COLUMNS: readonly ColumnDef[] = [
  { status: 'lead_form', label: 'Lead-Formular ausgefuellt', sort: 'oldest_first' },
  { status: 'followup_1', label: 'Follow-up 1', sort: 'oldest_first' },
  { status: 'followup_2', label: 'Follow-up 2', sort: 'oldest_first' },
  { status: 'in_kontakt', label: 'In Kontakt', sort: 'newest_first', isEndColumn: true },
  { status: 'positiv', label: 'Teamshop angelegt', sort: 'newest_first', isEndColumn: true },
  { status: 'negativ', label: 'Keine Rueckmeldung', sort: 'newest_first', isEndColumn: true },
  { status: 'negativ_hotlead', label: 'Keine Rueckmeldung Hotlead', sort: 'newest_first', isEndColumn: true },
];

export function getColumnDef(status: LeadStatus): ColumnDef | undefined {
  return COLUMNS.find((c) => c.status === status);
}
